import {
  CardSection,
  CardContentWrapper,
  CardContent,
  CardTitle,
  CardDescription,
  CardImageWrapper,
  CardImage,
  ActionButton,
} from "features/Research/v2/components/StockDetailPage/StrategyPromotionSection.styles";
import { Row, Col } from "react-bootstrap";
import { StrategyIcon2 } from "assets/icons/index";
import { noCodeStrategyBuilderImage } from "assets/images";
import { useNavigation } from "utils/navigate";

const BuildStrategy = () => {
  const { navigateToV2StrategyList } = useNavigation();

  const handleBuildStrategyClick = () => {
    navigateToV2StrategyList();
  };

  return (
    <CardSection bgColor="#EBEFF5">
      <CardContentWrapper>
        <Row className="align-items-center g-3">
          <Col xs={12} md={7} lg={12} xl={7}>
            <CardContent>
              <CardTitle>Build your own strategy!</CardTitle>
              <CardDescription>
                You can build your own strategy by choosing from over 1,000
                stocks and ETFs.
              </CardDescription>
              <ActionButton
                onClick={handleBuildStrategyClick}
                variant="primary"
                type="button"
                title="Go to Strategy Builder"
              >
                <img src={StrategyIcon2} alt="strategy" />
                Build now
              </ActionButton>
            </CardContent>
          </Col>
          <Col xs={12} md={5} lg={12} xl={5}>
            <CardImageWrapper>
              <CardImage
                src={noCodeStrategyBuilderImage}
                alt="Strategy builder illustration"
              />
            </CardImageWrapper>
          </Col>
        </Row>
      </CardContentWrapper>
    </CardSection>
  );
};

export default BuildStrategy;
